import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { ToolsService } from '../tools/tools.service';
import { SmsnotificationsService } from '../apiclient/smsnotifications/smsnotifications.service';
import { ResponseService } from '../manage/response/response.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})

export class AuthGuardService implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router,
    private tools: ToolsService,
    private smsApi: SmsnotificationsService,
    private responseServ: ResponseService,
    public translate: TranslateService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot|any,
    state: RouterStateSnapshot): Promise<any> {
    const that = this;

    return new Promise(function (resolve) {

      that.authService.checkIfAuth("intentconnect").then(function (data) {


        if (next.params.smsKey) {

          that.smsApi.getSmsNotification(next.params.smsKey).then(smsKeyData => {

            if (smsKeyData.code === 0) {

              that.smsApi.closeSmsNotification(next.params.smsKey).then(data => {
                // console.log(data);

                resolve(false);

                if (data.code === 0) {
                  that.tools.openSnackBar( that.translate.instant('merchantgard.assoc'), "great", 5000);
                } else {
                  that.tools.openSnackBar(that.responseServ.getErrorMessage(data.code), "warn", 5000);
                }

                that.tools.goRedirectPage(next.params.redirectPage);

              }).catch(err => {

                resolve(false);
                that.tools.openSnackBar(that.responseServ.getErrorMessage(500), "warn", 5000);
                that.tools.goRedirectPage(next.params.redirectPage);

              });

            } else {

              resolve(false);
              that.tools.openSnackBar(smsKeyData.message, "warn", 5000);
              that.tools.goRedirectPage(next.params.redirectPage);

            }

          });

        } else {

          resolve(false);
          that.tools.goRedirectPage(next.params.redirectPage);

        }

      }).catch(function () {

        resolve(true);

      })
    })


  }

}
